export default __webpack_public_path__ + "5bb2da6528e02862fc29a48d2dcdf2b4.png";